export default __webpack_public_path__ + "static/media/IMG_20220828_155148_817.ac2b3412.jpg";